import { useEffect } from 'react';
import { GOOGLE_FONTS, loadGoogleFont } from './fontUtils';

/**
 * Hook שטוען פונטים באופן אוטומטי מתוך HTML
 * שימוש: useFontLoader(htmlContent)
 * 
 * @param {string} htmlContent - תוכן HTML שעשוי להכיל פונטים
 */
export const useFontLoader = (htmlContent) => {
    useEffect(() => {
        if (!htmlContent || typeof htmlContent !== 'string') return;

        // בדיקה יעילה: האם שם הפונט מופיע בתוך ה-HTML
        GOOGLE_FONTS.forEach(font => {
            if (font.value === 'inherit') return;
            if (htmlContent.includes(font.value)) {
                loadGoogleFont(font.value);
            }
        });
    }, [htmlContent]);
};
